import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ManageLocationsRootParamList } from "../../../../types";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import { Receipt } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_LIST_RECEIPT_TEMPLATES, QUERY_LOCATIONS } from "../../common";
import { useFocusEffect } from "@react-navigation/native";
import React from "react";
import {
  Button,
  Divider,
  FlatActionList,
  FlatListSearchable,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { Location } from "@towersystems/roam-common/lib/generated-types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";

export type ManageLocationsScreenProps = NativeStackScreenProps<
  ManageLocationsRootParamList,
  "ManageLocationsScreen"
>;

export const ManageLocationsScreen = ({
  navigation,
}: ManageLocationsScreenProps) => {
  const transitionEnded = useHasTransitionEnded(navigation);

  const loadMoreList = useLoadMoreList<Location>({
    initialLoad: false,
    query: QUERY_LOCATIONS,
    resultKey: "locations",
    sort: { updatedAt: "DESC" },

    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          limit: 9999,
        },
      };
    },
  });

  useFocusEffect(
    // refresh the list when the screen is focused
    React.useCallback(() => {
      loadMoreList.loadMore(undefined, true);
    }, [])
  );

  const renderItem = React.useCallback(({ item }: { item: Location }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: item.name ?? "Unnamed Location",
          subTitle: "",
          onPress: () => {
            navigation.navigate("EditLocationScreen", {
              screen: "LocationFormScreen",
              locationId: item.id,
            });
          },
        }}
      ></FlatActionList.RenderItem>
    );
  }, []);

  if (
    (loadMoreList.loading && loadMoreList.items.length == 0) ||
    !transitionEnded
  ) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  return (
    <Page
      title="Retail Locations"
      secondaryTitle="Manage your store location configurations and visability"
      scrollable={true}
    >
      <FlatListSearchable
        renderSearchBarHeader={() => <View />}
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={loadMoreList.items ?? []}
      />
    </Page>
  );
};
